import { katTranslator } from '../../shared/i18n';

export const strings = {
  close_button_label: {
    'en-US': 'Close',
    'ar-AE': 'إغلاق',
    'bn-IN': 'বন্ধ করুন',
    'de-DE': 'Schließen',
    'es-ES': 'Cerrar',
    'es-MX': 'Cerrar',
    'fr-BE': 'Fermer',
    'fr-FR': 'Fermer',
    'gu-IN': 'બંધ કરો',
    'hi-IN': 'बंद करें',
    'it-IT': 'Chiudi',
    'ja-JP': '閉じる',
    'kn-IN': 'ಮುಚ್ಚಲಾಗಿದೆ',
    'ko-KR': '닫기',
    'ml-IN': 'അടയ്‌ക്കുക',
    'mr-IN': 'बंद करा',
    'nl-BE': 'Sluiten',
    'nl-NL': 'Sluiten',
    'pl-PL': 'Zamknij',
    'pt-BR': 'Fechar',
    'pt-PT': 'Fechar',
    'sv-SE': 'Stäng',
    'ta-IN': 'மூடுக',
    'te-IN': 'మూసివేయండి',
    'th-TH': 'ปิด',
    'tr-TR': 'Kapat',
    'vi-VN': 'Đóng',
    'zh-CN': '关闭',
    'zh-TW': '關閉',
  },
};

export default katTranslator(strings);
